import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  parenthesisInNegativeValue,
  tableIndexNumber,
  totalPages,
} from "../../utils/services";
import { useDebtorList } from "../../api/get";
import { CreditorDebitorListResponse } from "../../api/types";
import ChequeListCard from "../ChequeList/ChequeListCard/ChequeListCard";
import { Table } from "../CustomReactTable/CustomReactTable";
import { NoDataPage } from "../NoDataPage/NoDataPage";
import { Loader } from "../Loader/Loader";

interface ViewAlProps {
  viewAll: boolean;
}
export const DebtorList: React.FC<ViewAlProps> = ({ viewAll }) => {
  const [queryPageIndex, setQueryPageIndex] = useState(0);
  const [queryPageSize, setQueryPageSize] = useState(() => (viewAll ? 10 : 6));

  //useQuery
  const { data: debtorList, isLoading } = useDebtorList(
    queryPageIndex,
    queryPageSize,
  );

  const FormatTable = (
    array: CreditorDebitorListResponse[],
    pageIndex: number,
    pageSize: number,
  ) => {
    if (array) {
      const formatData = array?.map(
        (item: CreditorDebitorListResponse, index) => {
          return {
            s_n: tableIndexNumber(pageIndex, pageSize, index),
            name: item?.user_info?.name || "-",
            mobile_no: item?.user_info?.mobile_no || "-",
            amount: parenthesisInNegativeValue(item?.amount),
          };
        },
      );
      return formatData;
    }
    return [];
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.N",
        accessor: "s_n",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile No.",
        accessor: "mobile_no",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
    ],
    [],
  );

  return (
    <div className="dashboard-table">
      {!viewAll ? (
        <>
          {isLoading ? (
            <Loader loaderType="Spinner" />
          ) : debtorList && debtorList?.data.length > 0 ? (
            <>

              <div className="d-flex justify-content-end mb-2">
                <Link to={`/debto-list`}>
                  <p
                    className="small-button"
                    style={{ color: "#1DB195", cursor: "pointer" }}
                  >
                    View All
                  </p>
                </Link>
              </div>

              {debtorList?.data
                ?.slice(0, 5)
                ?.map((item: any, index: number) => (
                  <div key={index}>
                    <ChequeListCard
                      name={item?.user_info?.name}
                      mobile={item?.user_info?.mobile_no}
                      amount={item?.amount}
                      logo={item?.user_info?.name?.slice(0, 1)}
                    />
                  </div>
                ))}

            </>
          ) : (
            <NoDataPage description="Looks like there are no entries here yet" />
          )}
        </>
      ) : (
        <>
          <div className="head-section">
            <p className="small-title">Debtors List</p>
          </div>
          <Table
            excelDownload={true}
            loading={isLoading}
            columns={columns}
            data={
              debtorList
                ? FormatTable(debtorList.data, queryPageIndex, queryPageSize)
                : []
            }
            totalPages={
              debtorList &&
              totalPages(queryPageSize, debtorList.pagination.total_count)
            }
            totalEntries={debtorList && debtorList.pagination.total_count}
            queryPageIndex={queryPageIndex}
            setQueryPageIndex={setQueryPageIndex}
            queryPageSize={queryPageSize}
            setQueryPageSize={setQueryPageSize}
            showPageSize={true}
          />
        </>
      )}
    </div>
  );
};
